import styled, { createGlobalStyle } from 'styled-components'

/* Paleta ORDENO */
const C = {
  primary: '#0090D3', primaryInk: '#0072A8', tint: '#E6F4FB',
  ink: '#303030', inkStrong: '#1A1A1A', muted: '#696969', faint: '#9CA3AF',
  border: '#EBEBEB', border2: '#E0E0E0', bg: '#F5F5F5', surface: '#FFFFFF', surface2: '#F9FAFB', surface3: '#F3F4F6',
  ok: '#047857', okBg: '#D1FAE5', warn: '#B45309', warnBg: '#FEF3C7', bad: '#DC2626', badBg: '#FEE2E2',
  newC: '#6D28D9', newBg: '#EDE9FE',
}

export const Page = styled.div`
  background: ${C.bg};
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 26px 22px 60px;
`
export const SearchWrap = styled.div`
  position: relative;
`
export const SearchResults = styled.ul`
  position: absolute; z-index: 20; top: calc(100% + 4px); left: 0; right: 0;
  background: ${C.surface}; border: 1px solid ${C.border2}; border-radius: 10px;
  box-shadow: 0 8px 24px -12px rgba(20, 30, 45, .25);
  max-height: 260px; overflow-y: auto; padding: 4px; margin: 0; list-style: none;
  li { padding: 9px 10px; border-radius: 8px; cursor: pointer; display: flex; flex-direction: column; gap: 1px; }
  li:hover, li.active { background: ${C.tint}; }
  .nm { font-size: 13.5px; font-weight: 600; color: ${C.ink}; }
  .doc { font-size: 11.5px; color: ${C.muted}; font-variant-numeric: tabular-nums; }
  .none { padding: 10px; color: ${C.faint}; font-size: 12.5px; }
`
export const Topbar = styled.div`
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  margin: 0 0 20px;
`
export const Brand = styled.div`
  display: flex; align-items: center; gap: 12px;
  .logo { width: 38px; height: 38px; border-radius: 11px; background: ${C.primary};
    display: grid; place-items: center; color: #fff; font-weight: 800; font-size: 19px; }
  h1 { font-size: 19px; font-weight: 700; color: ${C.inkStrong}; }
  .sub { font-size: 12px; color: ${C.muted}; }
`
export const Tag = styled.span`
  font-size: 11px; font-weight: 600; color: ${C.primaryInk};
  background: ${C.tint}; padding: 5px 11px; border-radius: 32px;
`
export const Grid = styled.div`
  display: grid; grid-template-columns: 320px 1fr; gap: 18px; align-items: start;
  @media (max-width: 840px) { grid-template-columns: 1fr; }
`
export const SideCol = styled.div`
  position: sticky; top: 0;
  @media (max-width: 840px) { position: static; }
`
export const SecGrid = styled.div`
  display: grid; grid-template-columns: 1fr 1fr;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`
export const Card = styled.div`
  background: ${C.surface}; border: 1px solid ${C.border}; border-radius: 13px; overflow: hidden;
`
export const Pad = styled.div` padding: 18px; `
export const PanelTitle = styled.div`
  font-size: 12px; font-weight: 600; letter-spacing: .04em; text-transform: uppercase;
  color: ${C.faint}; margin-bottom: 12px;
`
export const Field = styled.label`
  display: block; font-size: 12px; font-weight: 600; color: ${C.muted}; margin: 0 0 6px;
`
export const Select = styled.select`
  width: 100%; font: inherit; font-size: 14px; color: ${C.ink}; background: ${C.surface};
  border: 1px solid ${C.border2}; border-radius: 9px; padding: 10px 12px;
  &:focus { outline: none; border-color: ${C.primary}; box-shadow: 0 0 0 3px ${C.tint}; }
`
export const Input = styled.input`
  width: 100%; font: inherit; font-size: 14px; color: ${C.ink}; background: ${C.surface};
  border: 1px solid ${C.border2}; border-radius: 9px; padding: 10px 12px;
  font-variant-numeric: tabular-nums;
  &:focus { outline: none; border-color: ${C.primary}; box-shadow: 0 0 0 3px ${C.tint}; }
  &[data-error='true'] { border-color: ${C.bad}; }
`
export const Divider = styled.div`
  display: flex; align-items: center; gap: 10px; color: ${C.faint}; font-size: 12px;
  margin: 14px 0; text-transform: uppercase; letter-spacing: .06em;
  &::before, &::after { content: ''; height: 1px; background: ${C.border}; flex: 1; }
`
export const Button = styled.button`
  width: 100%; font: inherit; font-weight: 600; font-size: 14px; cursor: pointer;
  border: 0; border-radius: 10px; padding: 12px 14px; background: ${C.primary}; color: #fff;
  display: flex; align-items: center; justify-content: center; gap: 8px; transition: filter .15s;
  &:hover { filter: brightness(1.05); }
  &:disabled { opacity: .6; cursor: progress; }
`
export const Hint = styled.div`
  font-size: 12px; color: ${C.faint}; margin-top: 10px; line-height: 1.45;
  code { background: ${C.surface3}; color: ${C.primaryInk}; padding: 1px 6px; border-radius: 5px; font-size: 11px; }
`
export const ClientList = styled.div`
  margin-top: 14px; display: flex; flex-direction: column; gap: 2px; max-height: 320px; overflow: auto;
  button { all: unset; cursor: pointer; padding: 9px 10px; border-radius: 8px; display: flex; flex-direction: column; gap: 1px; }
  button:hover { background: ${C.surface2}; }
  button.active { background: ${C.tint}; }
  .nm { font-size: 13.5px; font-weight: 600; color: ${C.ink}; }
  .doc { font-size: 11.5px; color: ${C.muted}; font-variant-numeric: tabular-nums; }
`
export const Result = styled.div` min-height: 440px; `
export const Empty = styled.div`
  min-height: 440px; display: flex; flex-direction: column; align-items: center; justify-content: center;
  text-align: center; color: ${C.faint}; gap: 12px; padding: 40px;
  svg { opacity: .45; }
  &[data-error='true'] { color: ${C.bad}; }
`
export const RHead = styled.div`
  display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-between; gap: 14px;
  padding: 18px; border-bottom: 1px solid ${C.border};
  h2 { font-size: 20px; font-weight: 700; color: ${C.inkStrong}; }
  .fant { font-size: 13px; color: ${C.muted}; margin-top: 2px; }
  .cnpj { font-size: 12.5px; color: ${C.faint}; margin-top: 5px; font-variant-numeric: tabular-nums; }
`
export const Verdict = styled.span<{ $v: string }>`
  font-size: 12.5px; font-weight: 600; padding: 6px 13px; border-radius: 32px;
  display: inline-flex; align-items: center; gap: 7px; white-space: nowrap;
  &::before { content: ''; width: 8px; height: 8px; border-radius: 50%; background: currentColor; }
  color: ${({ $v }) => ($v === 'Aprovado' ? C.ok : $v === 'Alerta' ? C.warn : C.bad)};
  background: ${({ $v }) => ($v === 'Aprovado' ? C.okBg : $v === 'Alerta' ? C.warnBg : C.badBg)};
`
export const ScoreBand = styled.div`
  display: grid; grid-template-columns: 190px 1fr; gap: 20px; padding: 20px 18px;
  border-bottom: 1px solid ${C.border}; align-items: center;
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`
export const Gauge = styled.div`
  position: relative; width: 190px; height: 112px; margin: 0 auto;
  .num { position: absolute; left: 0; right: 0; top: 50px; text-align: center; }
  .num b { font-size: 36px; font-weight: 800; letter-spacing: -.02em; font-variant-numeric: tabular-nums; }
  .num span { display: block; font-size: 11px; color: ${C.faint}; letter-spacing: .06em; text-transform: uppercase; margin-top: -3px; }
`
export const ScoreMeta = styled.div`
  display: flex; flex-direction: column; gap: 11px;
  .reason { font-size: 13px; color: ${C.muted}; }
  .reco { background: ${C.surface2}; border: 1px solid ${C.border}; border-radius: 11px; padding: 12px 14px; }
  .reco .lab { font-size: 11px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; color: ${C.faint}; }
  .reco .prazo { font-weight: 700; font-size: 19px; margin-top: 3px; color: ${C.inkStrong}; }
  .reco .risk { font-size: 12.5px; margin-top: 4px; color: ${C.muted}; }
`
export const Section = styled.div`
  padding: 18px;
  border-top: 1px solid ${C.border};
  h3 { font-size: 12px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; color: ${C.muted}; margin-bottom: 14px; }
  h3 .n { color: ${C.bad}; } h3 .g { color: ${C.ok}; }
  /* no grid de 2 colunas, a coluna da direita ganha divisória vertical */
  ${SecGrid} > &:nth-child(even) { border-left: 1px solid ${C.border}; }
  @media (max-width: 900px) { ${SecGrid} > &:nth-child(even) { border-left: none; } }
`
export const KV = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(155px, 1fr)); gap: 14px 18px;
  > div { min-width: 0; }
  .k { font-size: 11.5px; color: ${C.faint}; margin-bottom: 2px; display: flex; align-items: center; gap: 6px; overflow-wrap: anywhere; }
  .val { font-size: 14.5px; font-weight: 600; color: ${C.ink}; overflow-wrap: anywhere; line-height: 1.35; }
`
export const KVStack = styled(KV)`
  grid-template-columns: 1fr;
  gap: 12px;
`
export const ChipNew = styled.span`
  font-size: 9px; font-weight: 700; letter-spacing: .04em; color: ${C.newC}; background: ${C.newBg};
  padding: 2px 5px; border-radius: 5px; text-transform: uppercase;
`
export const Pends = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 12px;
`
export const Pend = styled.div<{ $state: 'hit' | 'clean' | '' }>`
  border: 1px solid ${C.border}; border-radius: 11px; padding: 12px 13px; background: ${C.surface2};
  .t { font-size: 12px; color: ${C.muted}; display: flex; align-items: center; justify-content: space-between; }
  .q { font-size: 23px; font-weight: 800; margin-top: 4px; font-variant-numeric: tabular-nums;
       color: ${({ $state }) => ($state === 'clean' ? C.ok : C.inkStrong)}; }
  .vv { font-size: 12px; color: ${C.faint}; font-variant-numeric: tabular-nums; }
  ${({ $state }) => $state === 'hit' && `
    background: ${C.badBg}; border-color: transparent;
    .t, .q, .vv { color: ${C.bad}; }
  `}
`
export const Socio = styled.div`
  display: flex; align-items: center; justify-content: space-between; padding: 10px 0;
  border-bottom: 1px solid ${C.border};
  &:last-child { border-bottom: none; }
  .nm { font-size: 14px; font-weight: 600; color: ${C.ink}; }
  .dc { font-size: 12px; color: ${C.faint}; font-variant-numeric: tabular-nums; }
`
export const Badge = styled.span<{ $bad?: boolean }>`
  display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 32px;
  font-size: 11px; font-weight: 600; white-space: nowrap;
  color: ${({ $bad }) => ($bad ? C.bad : C.ok)};
  background: ${({ $bad }) => ($bad ? C.badBg : C.okBg)};
`
export const Alerts = styled.div`
  display: flex; flex-direction: column; gap: 8px;
  .alert { display: flex; gap: 9px; font-size: 13.5px; padding: 10px 12px; border-radius: 9px;
    background: ${C.surface2}; border: 1px solid ${C.border}; color: ${C.ink}; }
  .alert .ic { flex: none; color: ${C.warn}; font-weight: 700; }
`
export const Footnote = styled.div`
  font-size: 11.5px; color: ${C.faint}; padding: 14px 18px; border-top: 1px solid ${C.border};
  display: flex; gap: 8px; align-items: flex-start; line-height: 1.5;
  code { background: ${C.surface3}; padding: 1px 6px; border-radius: 5px; font-size: 11px; color: ${C.primaryInk}; }
`
export const Skel = styled.div`
  animation: pulse 1.1s ease-in-out infinite; background: ${C.surface3}; border-radius: 8px;
  @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: .5; } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`

export const PrintBtn = styled.button`
  all: unset; cursor: pointer; font-size: 12.5px; font-weight: 600; color: ${C.primary};
  border: 1px solid ${C.border2}; border-radius: 8px; padding: 7px 13px;
  display: inline-flex; align-items: center; gap: 7px; transition: background .15s;
  &:hover { background: ${C.tint}; }
  &:focus-visible { outline: 2px solid ${C.primary}; outline-offset: 2px; }
`

/* Cabeçalho que só aparece na impressão */
export const PrintOnly = styled.div`
  display: none;
  @media print {
    display: block;
    padding: 0 18px 14px;
    border-bottom: 2px solid ${C.primary};
    margin-bottom: 6px;
    .pt-title { font-size: 17px; font-weight: 700; color: ${C.inkStrong}; }
    .pt-sub { font-size: 11px; color: ${C.muted}; margin-top: 2px; }
  }
`

export const PrintStyles = createGlobalStyle`
  @media print {
    @page { size: A4 portrait; margin: 12mm; }
    html, body { background: #fff !important; }
    /* isola: só a área da análise é impressa */
    body * { visibility: hidden !important; }
    .credito-root, .credito-root * { visibility: visible !important; }
    .credito-root {
      position: absolute !important; left: 0; top: 0; width: 100% !important;
      padding: 0 !important; overflow: visible !important; height: auto !important;
    }
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    .no-print { display: none !important; }
    .credito-grid { display: block !important; }
    .credito-result { border: none !important; box-shadow: none !important; border-radius: 0 !important; }
    .credito-rhead, .credito-scoreband, .credito-secgrid > * {
      break-inside: avoid; page-break-inside: avoid;
    }
  }
`
